import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let active = true;
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            if (active) { setUser(session?.user || null); setLoading(false); }
        });
        return () => { active = false; subscription.unsubscribe(); };
    }, []);
    async function login(email, password) {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        if (data.user?.app_metadata?.role !== 'ccm_admin') {
            await supabase.auth.signOut();
            throw new Error('This account does not have CCM administrator access.');
        }
        setUser(data.user);
    }
    async function logout() {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
        setUser(null);
    }
    return <AuthContext.Provider value={{ user, loading, isAdmin: user?.app_metadata?.role === 'ccm_admin', login, logout }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);
